import * as React from "react";
import { collapseReducer } from "./state/reducer";
import { CollapseContext } from "./CollapseContext";

interface ICollapseContextProviderProps {
  children: React.ReactNode;
}

export const CollapseContextProvider = (props: ICollapseContextProviderProps) => {
  const [state, dispatch] = React.useReducer(collapseReducer, new Set<string>());

  return <CollapseContext.Provider value={{ state, dispatch }}>{props.children}</CollapseContext.Provider>;
};
